<template>
<client-only>
    <el-card shadow="never" class="max-w-2xl mx-auto">
        <template #header>
            <h2 class="text-xl font-bold m-0">Settings</h2>
        </template>
        <Settings />
    </el-card>
</client-only>
</template>
